import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import '@/App.css';

// Import shared context and components from modular structure
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginSuccessScreen from './components/LoginSuccessScreen';
import useVisitTracker from './hooks/useVisitTracker';

// Import all pages
import {
  AuthPage,
  HomePage,
  CigarDetailPage,
  DiscussionsPage,
  NotesPage,
  PublicProfilePage,
  AddCigarPage,
  FavoritesPage,
  MySmokedPage,
  ProfilePage,
  MyCommentsPage,
  MyRatingsPage,
  MyNotesPage,
  BrowseBrandsPage,
  NotificationsPage,
  SettingsPage,
  LeaderboardsPage,
  AdminDashboard,
  BadgesPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  AnalyticsPage,
  DiscoverPage,
  AboutPage,
  ForumPage,
  LoungesPage,
  LoungeDetailPage,
  LoungeReviewsPage
} from './pages';

// Visit tracker wrapper component
function VisitTracker({ children }) {
  useVisitTracker();
  return children;
}

// Main App
function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <VisitTracker>
          <div className="App">
            <Routes>
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/login-success" element={<LoginSuccessScreen />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/cigar/:id" element={<CigarDetailPage />} />
              <Route path="/cigar/:id/discussions" element={<DiscussionsPage />} />
              <Route path="/cigar/:id/notes" element={<ProtectedRoute><NotesPage /></ProtectedRoute>} />
              <Route path="/add-cigar" element={<ProtectedRoute><AddCigarPage /></ProtectedRoute>} />
              <Route path="/favorites" element={<FavoritesPage />} />
              <Route path="/my-smoked" element={<ProtectedRoute><MySmokedPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/my-comments" element={<ProtectedRoute><MyCommentsPage /></ProtectedRoute>} />
              <Route path="/my-ratings" element={<ProtectedRoute><MyRatingsPage /></ProtectedRoute>} />
              <Route path="/my-notes" element={<ProtectedRoute><MyNotesPage /></ProtectedRoute>} />
              <Route path="/browse-brands" element={<BrowseBrandsPage />} />
              <Route path="/user/:userId" element={<PublicProfilePage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path="/leaderboards" element={<LeaderboardsPage />} />
              <Route path="/badges" element={<BadgesPage />} />
              <Route path="/discover" element={<ProtectedRoute><DiscoverPage /></ProtectedRoute>} />
              <Route path="/forum" element={<ForumPage />} />
              <Route path="/lounges" element={<LoungesPage />} />
              <Route path="/lounge/:id" element={<LoungeDetailPage />} />
              <Route path="/lounge/:id/reviews" element={<LoungeReviewsPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-center" />
          </div>
        </VisitTracker>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
